import { medtechApiClient } from '../../../api';
import { documentApi } from '../../../api/document';
import {
  ChangeControlAIResponse,
  QualioDocument,
} from '../../../api/model/document';
import { ChangeControlDTO } from '../../../types/DocumentCreate';
import { sanitizeDocumentSections } from '../../../util/DocumentSectionSanitizer';
import { aiApi } from './api';

export const aiService = {
  async generateChangeControl(
    document: QualioDocument,
    currentCC: ChangeControlDTO,
  ) {
    const versionsResponse = await medtechApiClient.get<DocumentVersion[]>(
      `documents/${document.id}/versions`,
    );
    const versions = versionsResponse.data;

    const majorVersions = versions.filter((doc) => doc.minor === '0');
    majorVersions.sort(
      (a, b) => Number.parseInt(b.major) - Number.parseInt(a.major),
    );

    const lastMajorVersion = majorVersions[0];

    if (!lastMajorVersion) {
      throw new Error('no prior major version');
    }

    const documentResponse = await medtechApiClient.get<QualioDocument>(
      `documents/${lastMajorVersion.document_id}`,
    );
    const lastMajorVersionDocument = documentResponse.data;

    const latestDocument = await documentApi.fetch(document.id.toString());

    const sanitizedCurrentDocumentSections = sanitizeDocumentSections(
      latestDocument.sections,
    );
    const sanitizedLastMajorVersionDocumentSections = sanitizeDocumentSections(
      lastMajorVersionDocument.sections,
    );
    const aiChangeControl = await aiApi.generateCC(
      latestDocument.title,
      sanitizedCurrentDocumentSections,
      sanitizedLastMajorVersionDocumentSections,
      currentCC,
    );

    return ChangeControlAIResponse.parse(aiChangeControl);
  },
};

export type DocumentVersion = {
  version: string;
  major: string;
  minor: string;
  document_id: number;
  status_id: string;
};
